import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לקרוא לזה בשם (בלי להתווכח עם זה)",
    opening: localizedGenderNode(
      [
      "היום אני לא מנסה להוכיח שאני מספיק/ה. אני רק מזהה את המשפט שחוזר — ונשאר/ת איתי."
    ],
      [
      "היום אני לא מנסה להוכיח שאני מספיק/ה. אני רק מזהה את המשפט שחוזר — ונשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת איטית.",
      "בלב: “זה קול של ‘לא מספיק/ה’. הוא לא אני.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת איטית.",
      "בלב: “זה קול של ‘לא מספיק/ה’. הוא לא אני.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי:\nמה המשפט המדויק שעולה לי היום? (“אני לא מספיק/ה כי…”)",
      "איפה בגוף אני מרגיש/ה את זה? (חזה/בטן/גרון/ראש)",
      "מתי זה הכי חזק? (בוקר/עבודה/זוגיות/חברים/רשתות)"
    ],
      [
      "אני שואל/ת את עצמי:\nמה המשפט המדויק שעולה לי היום? (“אני לא מספיק/ה כי…”)",
      "איפה בגוף אני מרגיש/ה את זה? (חזה/בטן/גרון/ראש)",
      "מתי זה הכי חזק? (בוקר/עבודה/זוגיות/חברים/רשתות)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "היום אני לא מנצח/ת את הקול. אני רק שם/ה עליו אור."
    ],
      [
      "סגירה",
      "היום אני לא מנצח/ת את הקול. אני רק שם/ה עליו אור."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: נשימה אחת + משפט: “זה קול. לא עובדה.”",
      "פעם אחת היום: נשימה אחת + משפט: “זה קול. לא עובדה.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "עובדה מול פירוש (CBT עדין)",
    opening: localizedGenderNode(
      [
      "היום אני מפריד/ה בין מה שקרה לבין מה שהמוח אומר שזה אומר עליי."
    ],
      [
      "היום אני מפריד/ה בין מה שקרה לבין מה שהמוח אומר שזה אומר עליי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אמת לא רוצהת להכאיב ככה.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אמת לא רוצהת להכאיב ככה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה העובדה היבשה שקרתה? (2 שורות, בלי פרשנות)",
      "איזה פירוש קפץ מיד? (“זה אומר שאני…”)",
      "איזו אמת עדינה אחרת אפשרית? (משפט אחד)"
    ],
      [
      "מה העובדה היבשה שקרתה? (2 שורות, בלי פרשנות)",
      "איזה פירוש קפץ מיד? (“זה אומר שאני…”)",
      "איזו אמת עדינה אחרת אפשרית? (משפט אחד)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "לא כל פירוש הוא אמת. לפעמים הוא פחד שמנסה להגן."
    ],
      [
      "סגירה",
      "לא כל פירוש הוא אמת. לפעמים הוא פחד שמנסה להגן."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: “עובדה ≠ פירוש.” ואז נשימה.",
      "פעם אחת היום: “עובדה ≠ פירוש.” ואז נשימה."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "הקול המבקר (להבדיל בין “אני” ל”מבקר”)",
    opening: localizedGenderNode(
      [
      "היום אני מזהה מי מדבר: אני — או המבקר הפנימי."
    ],
      [
      "היום אני מזהה מי מדבר: אני — או המבקר הפנימי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “מבקר הוא מנגנון, לא זהות.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “מבקר הוא מנגנון, לא זהות.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה המבקר אומר לי היום?",
      "אם המבקר היה דמות — איך הוא נראה/נשמע?",
      "איזה משפט הייתי אומר/ת לחבר אהוב במקומי?"
    ],
      [
      "מה המבקר אומר לי היום?",
      "אם המבקר היה דמות — איך הוא נראה/נשמע?",
      "איזה משפט הייתי אומר/ת לחבר אהוב במקומי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא רוצה/ת לדבר לעצמי בטון שמחליש אותי."
    ],
      [
      "סגירה",
      "אני לא רוצה/ת לדבר לעצמי בטון שמחליש אותי."
    ]
    ),
    action: localizedGenderNode(
      "כשעולה המבקר: “שלום מבקר. שמעתי.” ואז אני חוזר/ת לנשימה.",
      "כשעולה המבקר: “שלום מבקר. שמעתי.” ואז אני חוזר/ת לנשימה."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "איפה למדתי “לא מספיק/ה” (שורש עדין, בלי חפירה)",
    opening: localizedGenderNode(
      [
      "היום אני מזהה מאיפה זה התחיל — כדי שזה יפסיק להרגיש כמו אמת מוחלטת."
    ],
      [
      "היום אני מזהה מאיפה זה התחיל — כדי שזה יפסיק להרגיש כמו אמת מוחלטת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “מה שלמדתי פעם — לא רוצה לנהל אותי היום.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “מה שלמדתי פעם — לא רוצה לנהל אותי היום.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי בחיים שלי הרגשתי “לא מספיק/ה” בפעם הראשונה שאני זוכר/ת?",
      "מה רציתי לקבל אז ולא קיבלתי? (אישור/חום/נראות/הגנה)",
      "איזה משפט אני רוצה להגיד לעצמי הצעיר/ה היום? (משפט אחד)"
    ],
      [
      "מתי בחיים שלי הרגשתי “לא מספיק/ה” בפעם הראשונה שאני זוכר/ת?",
      "מה רציתי לקבל אז ולא קיבלתי? (אישור/חום/נראות/הגנה)",
      "איזה משפט אני רוצה להגיד לעצמי הצעיר/ה היום? (משפט אחד)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הכאב אמיתי — אבל הוא לא הוכחה שאני פחות."
    ],
      [
      "סגירה",
      "הכאב אמיתי — אבל הוא לא הוכחה שאני פחות."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד לעצמי: “הייתי ילד/ה. עשיתי הכי טוב שיכולתי.”",
      "משפט אחד לעצמי: “הייתי ילד/ה. עשיתי הכי טוב שיכולתי.”"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "השוואה לאחרים (להחזיר את המדידה הביתה)",
    opening: localizedGenderNode(
      [
      "היום אני מפסיק/ה למדוד את עצמי לפי אנשים אחרים."
    ],
      [
      "היום אני מפסיק/ה למדוד את עצמי לפי אנשים אחרים."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “השוואה היא כאב בתחפושת.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “השוואה היא כאב בתחפושת.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "את מי אני משווה לעצמי lately? ובאיזה נושא?",
      "מה אני אומר/ת לעצמי שזה אומר עליי?",
      "איזה דבר אחד אמיתי עליי שלא נכנס להשוואה הזאת?"
    ],
      [
      "את מי אני משווה לעצמי lately? ובאיזה נושא?",
      "מה אני אומר/ת לעצמי שזה אומר עליי?",
      "איזה דבר אחד אמיתי עליי שלא נכנס להשוואה הזאת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא נולדתי כדי לנצח אחרים. אני נולדתי כדי להיות אני."
    ],
      [
      "סגירה",
      "אני לא נולדתי כדי לנצח אחרים. אני נולדתי כדי להיות אני."
    ]
    ),
    action: localizedGenderNode(
      "היום אני עושה “עצירת השוואה” פעם אחת: נשימה + “חוזר/ת אליי.”",
      "היום אני עושה “עצירת השוואה” פעם אחת: נשימה + “חוזר/ת אליי.”"
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "לקבל מחמאה בלי לברוח",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת לקבל טוב — בלי להתכווץ."
    ],
      [
      "היום אני מתרגל/ת לקבל טוב — בלי להתכווץ."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “מותר לי לקבל.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “מותר לי לקבל.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך אני מגיב/ה למחמאה בדרך כלל? (מבטל/ת/צוחק/ת/מחליף נושא)",
      "מה מפחיד אותי בלקבל מחמאה? (ציפיות? חשיפה? פחד לא לעמוד בזה?)",
      "איך נשמעת תגובה אחת פשוטה ובריאה? (למשל: “תודה”)"
    ],
      [
      "איך אני מגיב/ה למחמאה בדרך כלל? (מבטל/ת/צוחק/ת/מחליף נושא)",
      "מה מפחיד אותי בלקבל מחמאה? (ציפיות? חשיפה? פחד לא לעמוד בזה?)",
      "איך נשמעת תגובה אחת פשוטה ובריאה? (למשל: “תודה”)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "לקבל מחמאה זה לא יהירות. זה כבוד עצמי."
    ],
      [
      "סגירה",
      "לקבל מחמאה זה לא יהירות. זה כבוד עצמי."
    ]
    ),
    action: localizedGenderNode(
      "אם מישהו אומר משהו טוב — אני עונה רק: “תודה.” בלי להסביר.",
      "אם מישהו אומר משהו טוב — אני עונה רק: “תודה.” בלי להסביר."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "ניסוי קטן (Behavior): לעשות למרות הקול",
    opening: localizedGenderNode(
      [
      "היום אני עושה דבר קטן גם אם הקול אומר “לא מספיק”."
    ],
      [
      "היום אני עושה דבר קטן גם אם הקול אומר “לא מספיק”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אני לא בוחר/ת/ה להרגיש מספיק כדי לפעול.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אני לא בוחר/ת/ה להרגיש מספיק כדי לפעול.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזו פעולה קטנה אני דוחה כי “אני לא מספיק/ה”?",
      "מה גרסה של 10% של הפעולה הזאת? (קטן מאוד)",
      "מה אני רוצה להוכיח לעצמי היום דרך 10%?"
    ],
      [
      "איזו פעולה קטנה אני דוחה כי “אני לא מספיק/ה”?",
      "מה גרסה של 10% של הפעולה הזאת? (קטן מאוד)",
      "מה אני רוצה להוכיח לעצמי היום דרך 10%?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הערך שלי לא תלוי ביציאה מושלמת. הוא תלוי בנאמנות לעצמי."
    ],
      [
      "סגירה",
      "הערך שלי לא תלוי ביציאה מושלמת. הוא תלוי בנאמנות לעצמי."
    ]
    ),
    action: localizedGenderNode(
      "אני עושה את ה־10% שלי. זה הכול.",
      "אני עושה את ה־10% שלי. זה הכול."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "אי־נוחות מותרת (ACT): לשאת תחושת “פחות” בלי לברוח",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת לשאת את התחושה דקה אחת — בלי לתקן אותה."
    ],
      [
      "היום אני מתרגל/ת לשאת את התחושה דקה אחת — בלי לתקן אותה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “תחושה היא גל. לא גזר דין.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “תחושה היא גל. לא גזר דין.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הטריגר הכי חזק שמעלה “אני לא מספיק/ה”?",
      "תרגול דקה אחת: אני נותן/ת לתחושה להיות כאן — בלי פעולה.\nמה קרה בגוף אחרי הדקה?",
      "מה למדתי על הגל? (האם הוא באמת לא עובר?)"
    ],
      [
      "מה הטריגר הכי חזק שמעלה “אני לא מספיק/ה”?",
      "תרגול דקה אחת: אני נותן/ת לתחושה להיות כאן — בלי פעולה.\nמה קרה בגוף אחרי הדקה?",
      "מה למדתי על הגל? (האם הוא באמת לא עובר?)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני מתחזק/ת לא כי נעלם לי הרגש — אלא כי נשארתי איתו."
    ],
      [
      "סגירה",
      "אני מתחזק/ת לא כי נעלם לי הרגש — אלא כי נשארתי איתו."
    ]
    ),
    action: localizedGenderNode(
      "דקה אחת בלבד. עקביות > כוח.",
      "דקה אחת בלבד. עקביות > כוח."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "ערך עצמי מול ביצועים",
    opening: localizedGenderNode(
      [
      "היום אני מפריד/ה בין “מי אני” לבין “איך הלך לי”."
    ],
      [
      "היום אני מפריד/ה בין “מי אני” לבין “איך הלך לי”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “כישלון הוא אירוע. לא זהות.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “כישלון הוא אירוע. לא זהות.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אני מערבב/ת ביצועים עם ערך עצמי?",
      "מה הייתי אומר/ת לעצמי אם זה היה רק “ניסיון” ולא מבחן?",
      "מה דבר אחד שאני כן עושה נכון — גם אם לא מושלם?"
    ],
      [
      "איפה אני מערבב/ת ביצועים עם ערך עצמי?",
      "מה הייתי אומר/ת לעצמי אם זה היה רק “ניסיון” ולא מבחן?",
      "מה דבר אחד שאני כן עושה נכון — גם אם לא מושלם?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני יכול/ה לשפר בלי להקטין את עצמי."
    ],
      [
      "סגירה",
      "אני יכול/ה לשפר בלי להקטין את עצמי."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום אני אומר/ת: “זה תהליך, לא הוכחה.”",
      "פעם אחת היום אני אומר/ת: “זה תהליך, לא הוכחה.”"
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "להיות “מספיק/ה” בלי להוכיח (Self-Compassion)",
    opening: localizedGenderNode(
      [
      "היום אני מחזיק/ה את עצמי כמו שהייתי מחזיק/ה אדם אהוב."
    ],
      [
      "היום אני מחזיק/ה את עצמי כמו שהייתי מחזיק/ה אדם אהוב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אני מדבר/ת אליי ברכות.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אני מדבר/ת אליי ברכות.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הייתי אומר/ת לחבר הכי קרוב שמרגיש “לא מספיק”? (5 שורות)",
      "איזה משפט אחד מתוך זה אני מוכן/ה להגיד לעצמי?",
      "איפה הכי קשה לי להיות רך/ה עם עצמי?"
    ],
      [
      "מה הייתי אומר/ת לחבר הכי קרוב שמרגיש “לא מספיק”? (5 שורות)",
      "איזה משפט אחד מתוך זה אני מוכן/ה להגיד לעצמי?",
      "איפה הכי קשה לי להיות רך/ה עם עצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "חמלה לא הופכת אותי חלש/ה. היא מחזירה לי כוח."
    ],
      [
      "סגירה",
      "חמלה לא הופכת אותי חלש/ה. היא מחזירה לי כוח."
    ]
    ),
    action: localizedGenderNode(
      "יד על חזה/בטן (אם נעים) + המשפט הרך שלי פעם אחת.",
      "יד על חזה/בטן (אם נעים) + המשפט הרך שלי פעם אחת."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "גבול מול קולות חיצוניים (“מה יגידו”)",
    opening: localizedGenderNode(
      [
      "היום אני מצמצם/ת את הרעש החיצוני שמנהל אותי."
    ],
      [
      "היום אני מצמצם/ת את הרעש החיצוני שמנהל אותי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אני לא רוצה/ת אישור כדי להיות.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אני לא רוצה/ת אישור כדי להיות.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה “מה יגידו” מנהל אותי הכי חזק?",
      "מה המחיר שאני משלם/ת כשאני חי/ה בשביל אישור?",
      "איזה גבול קטן אני שם השבוע מול הרעש הזה?"
    ],
      [
      "איפה “מה יגידו” מנהל אותי הכי חזק?",
      "מה המחיר שאני משלם/ת כשאני חי/ה בשביל אישור?",
      "איזה גבול קטן אני שם השבוע מול הרעש הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני יכול/ה להקשיב לאחרים — בלי לוותר עליי."
    ],
      [
      "סגירה",
      "אני יכול/ה להקשיב לאחרים — בלי לוותר עליי."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום אני בוחר/ת פעולה אחת “בשבילי” בלבד.",
      "פעם אחת היום אני בוחר/ת פעולה אחת “בשבילי” בלבד."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "לתקן את השפה (מילים בונות מציאות)",
    opening: localizedGenderNode(
      [
      "היום אני משנה טון פנימי קטן — וזה משנה כיוון."
    ],
      [
      "היום אני משנה טון פנימי קטן — וזה משנה כיוון."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “מילים הן בית.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “מילים הן בית.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה מילה אני מדביק/ה לעצמי? (“טיפש/ה”, “לא שווה”, “אפס”)",
      "איך אותה אמת נשמעת בשפה אנושית ולא אלימה?",
      "איזה משפט אחד אני מאמץ/ת לשבוע הקרוב?"
    ],
      [
      "איזה מילה אני מדביק/ה לעצמי? (“טיפש/ה”, “לא שווה”, “אפס”)",
      "איך אותה אמת נשמעת בשפה אנושית ולא אלימה?",
      "איזה משפט אחד אני מאמץ/ת לשבוע הקרוב?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא רוצה/ת לדבר לעצמי בשפה של מלחמה."
    ],
      [
      "סגירה",
      "אני לא רוצה/ת לדבר לעצמי בשפה של מלחמה."
    ]
    ),
    action: localizedGenderNode(
      "כל פעם שאני תופס/ת מילה אלימה — אני מחליף/ה אותה פעם אחת בלבד.",
      "כל פעם שאני תופס/ת מילה אלימה — אני מחליף/ה אותה פעם אחת בלבד."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "“מספיק/ה” כמסלול (לא כיעד)",
    opening: localizedGenderNode(
      [
      "היום אני בונה זהות של אדם שמתקדם — לא של אדם שמוכיח."
    ],
      [
      "היום אני בונה זהות של אדם שמתקדם — לא של אדם שמוכיח."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אני בדרך.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אני בדרך.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה ערך אחד הייתי רוצה להוביל אותי? (שקט/אמת/כבוד/צמיחה)",
      "איזה הרגל קטן משרת את הערך הזה השבוע?",
      "מה אני מבטיח/ה לעצמי ביום קשה? (משפט אחד)"
    ],
      [
      "איזה ערך אחד הייתי רוצה להוביל אותי? (שקט/אמת/כבוד/צמיחה)",
      "איזה הרגל קטן משרת את הערך הזה השבוע?",
      "מה אני מבטיח/ה לעצמי ביום קשה? (משפט אחד)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "מספיק/ה זה לא משהו שמרוויחים. זה משהו שמתרגלים לחיות ממנו."
    ],
      [
      "סגירה",
      "מספיק/ה זה לא משהו שמרוויחים. זה משהו שמתרגלים לחיות ממנו."
    ]
    ),
    action: localizedGenderNode(
      "אני מתכנן/ת דבר קטן אחד לשבוע שמחזיר לי יציבות (בלי דרמה).",
      "אני מתכנן/ת דבר קטן אחד לשבוע שמחזיר לי יציבות (בלי דרמה)."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה (משפט חזרה לימים קשים)",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת בלי “ניצחון”. אני מסיים/ת עם נאמנות לעצמי."
    ],
      [
      "היום אני מסיים/ת בלי “ניצחון”. אני מסיים/ת עם נאמנות לעצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אני נשאר/ת איתי.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת. “אני נשאר/ת איתי.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה השתנה בי קצת במסע הזה? (3 דברים)",
      "מה נהיה ברור יותר לגבי הקול “לא מספיק/ה”?",
      "משפט חזרה לימים קשים (קצר, ברור, בכיס):"
    ],
      [
      "מה השתנה בי קצת במסע הזה? (3 דברים)",
      "מה נהיה ברור יותר לגבי הקול “לא מספיק/ה”?",
      "משפט חזרה לימים קשים (קצר, ברור, בכיס):"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה סופית למסע",
      "אני לא מבטל/ת את הקול.",
      "אני פשוט מפסיק/ה לתת לו לנהל את החיים שלי.",
      "אני ממשיך/ה ללכת —",
      "לאט, בשקט, עם עצמי.",
      "וזה כוח."
    ],
      [
      "סגירה סופית למסע",
      "אני לא מבטל/ת את הקול.",
      "אני פשוט מפסיק/ה לתת לו לנהל את החיים שלי.",
      "אני ממשיך/ה ללכת —",
      "לאט, בשקט, עם עצמי.",
      "וזה כוח."
    ]
    ),
    action: localizedGenderNode(
      "אני עושה פעולה אחת שמסמלת “אני בעדי”: סדר קטן / הליכה / כתיבה של 5 שורות.",
      "אני עושה פעולה אחת שמסמלת “אני בעדי”: סדר קטן / הליכה / כתיבה של 5 שורות."
    ),
  },
].map(buildNormalizedDay);

export const iAmNotEnoughBlueprintHe = buildNormalizedPilotBlueprint({
  id: "i_am_not_enough_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "i_am_not_enough",
  category: "general",
  journeyName: {
    he: "תחושת “אני לא מספיק/ה”",
    en: "I’m Not Enough",
    es: "No soy suficiente",
  },
  days,
});

export default iAmNotEnoughBlueprintHe;
